import { usePermissionsStore } from '@/stores/permissions'

/*
 * v-can directive — hides an element when the user lacks the permission.
 *   v-can="'reservation.create'"
 *   v-can="['reservation.create', 'reservation.update']"   // any of
 *   v-can="{ code: 'payment.void', scope: 'hotel' }"
 *
 * Server-side checks remain the source of truth; this only gates the UI.
 */
function resolve(binding) {
  const store = usePermissionsStore()
  const value = binding.value

  if (typeof value === 'string') return store.can(value)
  if (Array.isArray(value)) return value.some((code) => store.can(code))
  if (value && value.code) return store.can(value.code, value.scope)
  return false
}

function apply(el, binding) {
  el.style.display = resolve(binding) ? '' : 'none'
}

export const canDirective = {
  mounted: apply,
  updated: apply
}
